export enum Gender {
  MALE = 'Masculino',
  FEMALE = 'Feminino'
}

export const gender = [
  {
    label: 'Masculino',
    value: Gender.MALE
  },
  {
    label: 'Feminino',
    value: Gender.FEMALE
  }
]

export enum GenderNew {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  UNDEFINED = 'UNDEFINED',
  IGNORED = 'IGNORED'
}

export enum GenderNewTranslated {
  MALE = 'Masculino',
  FEMALE = 'Feminino',
  UNDEFINED = 'Indefinido',
  IGNORED = 'Não respondido'
}

export const genderNew = [
  {
    label: 'Masculino',
    value: GenderNew.MALE
  },
  {
    label: 'Feminino',
    value: GenderNew.FEMALE
  },
  {
    label: 'Indefinido',
    value: GenderNew.UNDEFINED
  },
  {
    label: 'Não respondido',
    value: GenderNew.IGNORED
  }
]
